// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.sidebar {
  background: #F6F6F6;
  display: flex;
  flex-direction: column;
  padding: 0;
  border-right: 1px solid #e9ecef;
  box-shadow: 2px 0 8px rgba(23,32,43,0.04);
  height: 100vh;
  box-sizing: border-box;
  width: 320px;
  transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1);
  overflow: hidden;
}

.sidebar:not(.open) {
  width: 80px;
  transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1);
}

.sidebar:not(.open) .right-column {
  opacity: 0;
  transform: translateX(-20px);
  transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1);
}

.sidebar.open .right-column {
  opacity: 1;
  transform: translateX(0);
  transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1);
}

.sidebar:not(.open) .sidebar-header {
  flex-direction: column;
  align-items: center;
  gap: 16px;
  padding: 16px 0;
  transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1);
}

.sidebar.open .sidebar-header {
  flex-direction: row;
  align-items: center;
  justify-content: space-between;
  padding: 16px 25px;
  transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1);
}

.sidebar:not(.open) .logo-m {
  margin-bottom: 8px;
  transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1);
}

.sidebar.open .logo-m {
  margin-bottom: 0;
  transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1);
}

.sidebar:not(.open) .battery-btn {
  opacity: 0;
  transform: scale(0.8);
  transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1);
}

.sidebar.open .battery-btn {
  opacity: 1;
  transform: scale(1);
  transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1);
}

.sidebar:not(.open) .sidebar-main-layout {
  padding: 20px 17px 0 17px;
  transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1);
}

.sidebar.open .sidebar-main-layout {
  padding: 20px 20px 0 20px;
  transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1);
}

.sidebar:not(.open) .logout-section {
  opacity: 0;
  transform: translateY(10px);
  transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1);
}

.sidebar.open .logout-section {
  opacity: 1;
  transform: translateY(0);
  transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1);
}

.sidebar-header {
  padding: 16px 25px;
  background: #F6F6F6;
  display: flex;
  align-items: center;
  justify-content: space-between;
  transition: all 0.3s ease;
}

.logo-m {
  display: flex;
  align-items: center;
  justify-content: center;
  font-weight: bold;
}

.battery-btn {
  border: none;
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  transition: all 0.3s ease;
  padding: 0;
}

.battery-btn:hover {
  transform: scale(1.05);
}

.sidebar-content {
  flex: 1 1;
  display: flex;
  flex-direction: column;
  min-height: 0;
  overflow: hidden;
}

.sidebar-main-layout {
  flex: 1 1;
  display: flex;
  gap: 20px;
  padding: 20px 20px 0 20px;
}

.left-column {
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 16px;
  min-width: 44px;
}

.right-column {
  flex: 1 1;
  display: flex;
  flex-direction: column;
  min-height: 0;
  overflow: hidden;
}

.circular-buttons {
  display: flex;
  flex-direction: column;
  align-items: center;
}

.circular-btn {
  width: 44px;
  height: 44px;
  border-radius: 50%;
  border: none;
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  transition: all 0.3s ease;
  background: #E2E2E2;
  margin-top: 30px;
}

.circular-btn:hover {
  background: #e9ecef;
  transform: scale(1.05);
}

.circular-btn.edit-btn {
  color: #007bff;
}

.circular-btn.edit-btn:hover {
  background: #e9ecef;
}

.new-chat-text {
  display: flex;
  align-items: center;
  gap: 8px;
  color: #878787;
  font-size: 12px;
  font-weight: 400;
  margin-bottom: 16px;
  cursor: pointer;
}

.new-chat-text2 {
  display: flex;
  align-items: center;
  color: #878787;
  font-size: 10px;
  font-weight: 400;
  margin-bottom: 16px;
}

.chats-section {
  flex: 1 1;
  display: flex;
  flex-direction: column;
  min-height: 0;
  overflow: hidden;
}

.chats-heading {
  font-size: 18px;
  font-weight: bold;
  color: #212529;
  margin: 0 0 16px 0;
  padding: 0;
  border-bottom: 0.5px solid #CACACA;
  padding-top: 16px;
  padding-bottom: 16px;
  flex-shrink: 0;
}

.chat-list {
  list-style: none;
  padding: 0;
  margin: 0;
  flex: 1 1;
  overflow-y: auto;
  overflow-x: hidden;
  min-height: 0;
  max-height: calc(100vh - 300px);
  scrollbar-width: thin;
  scrollbar-color: transparent transparent;
}

.chat-list::-webkit-scrollbar {
  width: 6px;
  background: transparent;
}

.chat-list::-webkit-scrollbar-track {
  background: transparent;
}

.chat-list::-webkit-scrollbar-thumb {
  background: transparent;
  border-radius: 3px;
  -webkit-transition: background 0.2s ease;
  transition: background 0.2s ease;
}

.chat-list:hover::-webkit-scrollbar-thumb {
  background: #c1c1c1;
}

.chat-list::-webkit-scrollbar-thumb:hover {
  background: #a8a8a8;
}

/* Show scrollbar when scrolling */
.chat-list:active::-webkit-scrollbar-thumb {
  background: #c1c1c1;
}

/* For Firefox */
.chat-list:hover {
  scrollbar-color: #c1c1c1 transparent;
}

.chat-list-item {
  min-width: 0;
  margin: 0 0 8px 0;
  padding: 10px 10px;
  font-size: 12px;
  border-radius: 8px;
  background: #F6F6F6;
  border: 1.75px solid #F6F6F6;
  display: flex;
  align-items: center;
  justify-content: space-between;
  transition: all 0.2s ease;
  cursor: pointer;
}

.chat-list-item:hover {
  border: 1.75px solid #e9ecef;
}

.chat-list-item.active {
  border: 1.75px solid #e9ecef;
}

.chat-title {
  flex: 1 1;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  color: #878787;
}

.delete-chat-btn {
  background: transparent;
  border: none;
  color: #dc3545;
  cursor: pointer;
  padding: 2px;
  border-radius: 4px;
  display: flex;
  align-items: center;
  justify-content: center;
  transition: all 0.2s ease;
  margin-left: 8px;
}

.delete-chat-btn:hover {
  background: #f8d7da;
  color: #721c24;
}

.chat-title-input {
  font-size: 14px;
  border: 1px solid #2196f3;
  border-radius: 4px;
  padding: 4px 8px;
  width: 100%;
  outline: none;
  color: #495057;
  background: white;
}

.empty-chats-message {
  color: #6c757d;
  font-style: italic;
  text-align: center;
  padding: 20px;
}

.loading-chat-item {
  display: flex;
  align-items: center;
  gap: 8px;
  color: #132775;
}

.spinner-small {
  width: 16px;
  height: 16px;
  border: 2px solid rgba(19, 39, 117, 0.15);
  border-top: 2px solid #132775;
  border-radius: 50%;
  animation: spin 1s linear infinite;
}

@keyframes spin {
  0% { transform: rotate(0deg); }
  100% { transform: rotate(360deg); }
}

.loading-text {
  font-size: 14px;
  color: #132775;
  font-weight: 500;
}

.logout-section {
  padding: 0 20px 20px 20px;
  margin-top: auto;
  display: flex;
  justify-content: center;
}

.logout-btn {
  width: 50%;
  padding: 12px 0;
  background: #F6F6F6;
  color: #000;
  border: 1px solid #000;
  border-radius: 8px;
  font-size: 14px;
  font-weight: 500;
  cursor: pointer;
  transition: all 0.2s ease;
}

.logout-btn:hover {
  transform: translateY(-2px);
}

.logout-btn:active {
  transform: translateY(0);
}

@media (max-width: 900px) {
  .sidebar {
    position: fixed;
    top: 0;
    left: 0;
    height: 100vh;
    width: 80vw;
    max-width: 340px;
    min-width: 220px;
    z-index: 1202;
    background: #f8f9fa;
    box-shadow: 2px 0 16px rgba(23,32,43,0.12);
    transform: translateX(-100%);
    transition: transform 0.3s cubic-bezier(0.4, 0, 0.2, 1);
    border-right: 1px solid #e9ecef;
    overflow: hidden;
  }
  
  .sidebar.open {
    transform: translateX(0);
  }

  .sidebar:not(.open) {
    width: 80vw;
    max-width: 340px;
    min-width: 220px;
  }

  .sidebar:not(.open) .sidebar-content {
    display: flex;
  }

  .sidebar:not(.open) .sidebar-header {
    flex-direction: row;
    align-items: center;
    justify-content: space-between;
    padding: 16px 20px;
  }

  .sidebar:not(.open) .logo-m {
    margin-bottom: 0;
  }

  .sidebar:not(.open) .battery-btn {
    margin-top: 0;
    opacity: 1;
    transform: scale(1);
  }

  .sidebar-header {
    padding: 12px 16px;
  }
  
  .new-chat-section {
    padding: 16px;
  }
  
  .chats-section {
    padding: 0 16px 16px 16px;
  }
  
  .chat-list-item {
    padding: 10px 12px;
    font-size: 13px;
    margin-bottom: 6px;
  }
  
  .circular-btn {
    width: 44px;
    height: 44px;
  }
} `, "",{"version":3,"sources":["webpack://./src/components/Sidebar/Sidebar.css"],"names":[],"mappings":"AAAA;EACE,mBAAmB;EACnB,aAAa;EACb,sBAAsB;EACtB,UAAU;EACV,+BAA+B;EAC/B,yCAAyC;EACzC,aAAa;EACb,sBAAsB;EACtB,YAAY;EACZ,iDAAiD;EACjD,gBAAgB;AAClB;;AAEA;EACE,WAAW;EACX,iDAAiD;AACnD;;AAEA;EACE,UAAU;EACV,4BAA4B;EAC5B,iDAAiD;AACnD;;AAEA;EACE,UAAU;EACV,wBAAwB;EACxB,iDAAiD;AACnD;;AAEA;EACE,sBAAsB;EACtB,mBAAmB;EACnB,SAAS;EACT,eAAe;EACf,iDAAiD;AACnD;;AAEA;EACE,mBAAmB;EACnB,mBAAmB;EACnB,8BAA8B;EAC9B,kBAAkB;EAClB,iDAAiD;AACnD;;AAEA;EACE,kBAAkB;EAClB,iDAAiD;AACnD;;AAEA;EACE,gBAAgB;EAChB,iDAAiD;AACnD;;AAEA;EACE,UAAU;EACV,qBAAqB;EACrB,iDAAiD;AACnD;;AAEA;EACE,UAAU;EACV,mBAAmB;EACnB,iDAAiD;AACnD;;AAEA;EACE,yBAAyB;EACzB,iDAAiD;AACnD;;AAEA;EACE,yBAAyB;EACzB,iDAAiD;AACnD;;AAEA;EACE,UAAU;EACV,2BAA2B;EAC3B,iDAAiD;AACnD;;AAEA;EACE,UAAU;EACV,wBAAwB;EACxB,iDAAiD;AACnD;;AAEA;EACE,kBAAkB;EAClB,mBAAmB;EACnB,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,yBAAyB;AAC3B;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,iBAAiB;AACnB;;AAEA;EACE,YAAY;EACZ,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,eAAe;EACf,yBAAyB;EACzB,UAAU;AACZ;;AAEA;EACE,sBAAsB;AACxB;;AAEA;EACE,SAAO;EACP,aAAa;EACb,sBAAsB;EACtB,aAAa;EACb,gBAAgB;AAClB;;AAEA;EACE,SAAO;EACP,aAAa;EACb,SAAS;EACT,yBAAyB;AAC3B;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,SAAS;EACT,eAAe;AACjB;;AAEA;EACE,SAAO;EACP,aAAa;EACb,sBAAsB;EACtB,aAAa;EACb,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,mBAAmB;AACrB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,YAAY;EACZ,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,eAAe;EACf,yBAAyB;EACzB,mBAAmB;EACnB,gBAAgB;AAClB;;AAEA;EACE,mBAAmB;EACnB,sBAAsB;AACxB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,cAAc;EACd,eAAe;EACf,gBAAgB;EAChB,mBAAmB;EACnB,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,cAAc;EACd,eAAe;EACf,gBAAgB;EAChB,mBAAmB;AACrB;;AAEA;EACE,SAAO;EACP,aAAa;EACb,sBAAsB;EACtB,aAAa;EACb,gBAAgB;AAClB;;AAEA;EACE,eAAe;EACf,iBAAiB;EACjB,cAAc;EACd,kBAAkB;EAClB,UAAU;EACV,kCAAkC;EAClC,iBAAiB;EACjB,oBAAoB;EACpB,cAAc;AAChB;;AAEA;EACE,gBAAgB;EAChB,UAAU;EACV,SAAS;EACT,SAAO;EACP,gBAAgB;EAChB,kBAAkB;EAClB,aAAa;EACb,+BAA+B;EAC/B,qBAAqB;EACrB,wCAAwC;AAC1C;;AAEA;EACE,UAAU;EACV,uBAAuB;AACzB;;AAEA;EACE,uBAAuB;AACzB;;AAEA;EACE,uBAAuB;EACvB,kBAAkB;EAClB,wCAAgC;EAAhC,gCAAgC;AAClC;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;AACrB;;AAEA,kCAAkC;AAClC;EACE,mBAAmB;AACrB;;AAEA,gBAAgB;AAChB;EACE,oCAAoC;AACtC;;AAEA;EACE,YAAY;EACZ,iBAAiB;EACjB,kBAAkB;EAClB,eAAe;EACf,kBAAkB;EAClB,mBAAmB;EACnB,4BAA4B;EAC5B,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,yBAAyB;EACzB,eAAe;AACjB;;AAEA;EACE,4BAA4B;AAC9B;;AAEA;EACE,4BAA4B;AAC9B;;AAEA;EACE,SAAO;EACP,gBAAgB;EAChB,uBAAuB;EACvB,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,uBAAuB;EACvB,YAAY;EACZ,cAAc;EACd,eAAe;EACf,YAAY;EACZ,kBAAkB;EAClB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,yBAAyB;EACzB,gBAAgB;AAClB;;AAEA;EACE,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,eAAe;EACf,yBAAyB;EACzB,kBAAkB;EAClB,gBAAgB;EAChB,WAAW;EACX,aAAa;EACb,cAAc;EACd,iBAAiB;AACnB;;AAEA;EACE,cAAc;EACd,kBAAkB;EAClB,kBAAkB;EAClB,aAAa;AACf;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,cAAc;AAChB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,yCAAyC;EACzC,6BAA6B;EAC7B,kBAAkB;EAClB,kCAAkC;AACpC;;AAEA;EACE,KAAK,uBAAuB,EAAE;EAC9B,OAAO,yBAAyB,EAAE;AACpC;;AAEA;EACE,eAAe;EACf,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,yBAAyB;EACzB,gBAAgB;EAChB,aAAa;EACb,uBAAuB;AACzB;;AAEA;EACE,UAAU;EACV,eAAe;EACf,mBAAmB;EACnB,WAAW;EACX,sBAAsB;EACtB,kBAAkB;EAClB,eAAe;EACf,gBAAgB;EAChB,eAAe;EACf,yBAAyB;AAC3B;;AAEA;EACE,2BAA2B;AAC7B;;AAEA;EACE,wBAAwB;AAC1B;;AAEA;EACE;IACE,eAAe;IACf,MAAM;IACN,OAAO;IACP,aAAa;IACb,WAAW;IACX,gBAAgB;IAChB,gBAAgB;IAChB,aAAa;IACb,mBAAmB;IACnB,0CAA0C;IAC1C,4BAA4B;IAC5B,uDAAuD;IACvD,+BAA+B;IAC/B,gBAAgB;EAClB;;EAEA;IACE,wBAAwB;EAC1B;;EAEA;IACE,WAAW;IACX,gBAAgB;IAChB,gBAAgB;EAClB;;EAEA;IACE,aAAa;EACf;;EAEA;IACE,mBAAmB;IACnB,mBAAmB;IACnB,8BAA8B;IAC9B,kBAAkB;EACpB;;EAEA;IACE,gBAAgB;EAClB;;EAEA;IACE,aAAa;IACb,UAAU;IACV,mBAAmB;EACrB;;EAEA;IACE,kBAAkB;EACpB;;EAEA;IACE,aAAa;EACf;;EAEA;IACE,yBAAyB;EAC3B;;EAEA;IACE,kBAAkB;IAClB,eAAe;IACf,kBAAkB;EACpB;;EAEA;IACE,WAAW;IACX,YAAY;EACd;AACF","sourcesContent":[".sidebar {\n  background: #F6F6F6;\n  display: flex;\n  flex-direction: column;\n  padding: 0;\n  border-right: 1px solid #e9ecef;\n  box-shadow: 2px 0 8px rgba(23,32,43,0.04);\n  height: 100vh;\n  box-sizing: border-box;\n  width: 320px;\n  transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1);\n  overflow: hidden;\n}\n\n.sidebar:not(.open) {\n  width: 80px;\n  transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1);\n}\n\n.sidebar:not(.open) .right-column {\n  opacity: 0;\n  transform: translateX(-20px);\n  transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1);\n}\n\n.sidebar.open .right-column {\n  opacity: 1;\n  transform: translateX(0);\n  transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1);\n}\n\n.sidebar:not(.open) .sidebar-header {\n  flex-direction: column;\n  align-items: center;\n  gap: 16px;\n  padding: 16px 0;\n  transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1);\n}\n\n.sidebar.open .sidebar-header {\n  flex-direction: row;\n  align-items: center;\n  justify-content: space-between;\n  padding: 16px 25px;\n  transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1);\n}\n\n.sidebar:not(.open) .logo-m {\n  margin-bottom: 8px;\n  transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1);\n}\n\n.sidebar.open .logo-m {\n  margin-bottom: 0;\n  transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1);\n}\n\n.sidebar:not(.open) .battery-btn {\n  opacity: 0;\n  transform: scale(0.8);\n  transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1);\n}\n\n.sidebar.open .battery-btn {\n  opacity: 1;\n  transform: scale(1);\n  transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1);\n}\n\n.sidebar:not(.open) .sidebar-main-layout {\n  padding: 20px 17px 0 17px;\n  transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1);\n}\n\n.sidebar.open .sidebar-main-layout {\n  padding: 20px 20px 0 20px;\n  transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1);\n}\n\n.sidebar:not(.open) .logout-section {\n  opacity: 0;\n  transform: translateY(10px);\n  transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1);\n}\n\n.sidebar.open .logout-section {\n  opacity: 1;\n  transform: translateY(0);\n  transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1);\n}\n\n.sidebar-header {\n  padding: 16px 25px;\n  background: #F6F6F6;\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  transition: all 0.3s ease;\n}\n\n.logo-m {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  font-weight: bold;\n}\n\n.battery-btn {\n  border: none;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  cursor: pointer;\n  transition: all 0.3s ease;\n  padding: 0;\n}\n\n.battery-btn:hover {\n  transform: scale(1.05);\n}\n\n.sidebar-content {\n  flex: 1;\n  display: flex;\n  flex-direction: column;\n  min-height: 0;\n  overflow: hidden;\n}\n\n.sidebar-main-layout {\n  flex: 1;\n  display: flex;\n  gap: 20px;\n  padding: 20px 20px 0 20px;\n}\n\n.left-column {\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  gap: 16px;\n  min-width: 44px;\n}\n\n.right-column {\n  flex: 1;\n  display: flex;\n  flex-direction: column;\n  min-height: 0;\n  overflow: hidden;\n}\n\n.circular-buttons {\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n}\n\n.circular-btn {\n  width: 44px;\n  height: 44px;\n  border-radius: 50%;\n  border: none;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  cursor: pointer;\n  transition: all 0.3s ease;\n  background: #E2E2E2;\n  margin-top: 30px;\n}\n\n.circular-btn:hover {\n  background: #e9ecef;\n  transform: scale(1.05);\n}\n\n.circular-btn.edit-btn {\n  color: #007bff;\n}\n\n.circular-btn.edit-btn:hover {\n  background: #e9ecef;\n}\n\n.new-chat-text {\n  display: flex;\n  align-items: center;\n  gap: 8px;\n  color: #878787;\n  font-size: 12px;\n  font-weight: 400;\n  margin-bottom: 16px;\n  cursor: pointer;\n}\n\n.new-chat-text2 {\n  display: flex;\n  align-items: center;\n  color: #878787;\n  font-size: 10px;\n  font-weight: 400;\n  margin-bottom: 16px;\n}\n\n.chats-section {\n  flex: 1;\n  display: flex;\n  flex-direction: column;\n  min-height: 0;\n  overflow: hidden;\n}\n\n.chats-heading {\n  font-size: 18px;\n  font-weight: bold;\n  color: #212529;\n  margin: 0 0 16px 0;\n  padding: 0;\n  border-bottom: 0.5px solid #CACACA;\n  padding-top: 16px;\n  padding-bottom: 16px;\n  flex-shrink: 0;\n}\n\n.chat-list {\n  list-style: none;\n  padding: 0;\n  margin: 0;\n  flex: 1;\n  overflow-y: auto;\n  overflow-x: hidden;\n  min-height: 0;\n  max-height: calc(100vh - 300px);\n  scrollbar-width: thin;\n  scrollbar-color: transparent transparent;\n}\n\n.chat-list::-webkit-scrollbar {\n  width: 6px;\n  background: transparent;\n}\n\n.chat-list::-webkit-scrollbar-track {\n  background: transparent;\n}\n\n.chat-list::-webkit-scrollbar-thumb {\n  background: transparent;\n  border-radius: 3px;\n  transition: background 0.2s ease;\n}\n\n.chat-list:hover::-webkit-scrollbar-thumb {\n  background: #c1c1c1;\n}\n\n.chat-list::-webkit-scrollbar-thumb:hover {\n  background: #a8a8a8;\n}\n\n/* Show scrollbar when scrolling */\n.chat-list:active::-webkit-scrollbar-thumb {\n  background: #c1c1c1;\n}\n\n/* For Firefox */\n.chat-list:hover {\n  scrollbar-color: #c1c1c1 transparent;\n}\n\n.chat-list-item {\n  min-width: 0;\n  margin: 0 0 8px 0;\n  padding: 10px 10px;\n  font-size: 12px;\n  border-radius: 8px;\n  background: #F6F6F6;\n  border: 1.75px solid #F6F6F6;\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  transition: all 0.2s ease;\n  cursor: pointer;\n}\n\n.chat-list-item:hover {\n  border: 1.75px solid #e9ecef;\n}\n\n.chat-list-item.active {\n  border: 1.75px solid #e9ecef;\n}\n\n.chat-title {\n  flex: 1;\n  overflow: hidden;\n  text-overflow: ellipsis;\n  white-space: nowrap;\n  color: #878787;\n}\n\n.delete-chat-btn {\n  background: transparent;\n  border: none;\n  color: #dc3545;\n  cursor: pointer;\n  padding: 2px;\n  border-radius: 4px;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  transition: all 0.2s ease;\n  margin-left: 8px;\n}\n\n.delete-chat-btn:hover {\n  background: #f8d7da;\n  color: #721c24;\n}\n\n.chat-title-input {\n  font-size: 14px;\n  border: 1px solid #2196f3;\n  border-radius: 4px;\n  padding: 4px 8px;\n  width: 100%;\n  outline: none;\n  color: #495057;\n  background: white;\n}\n\n.empty-chats-message {\n  color: #6c757d;\n  font-style: italic;\n  text-align: center;\n  padding: 20px;\n}\n\n.loading-chat-item {\n  display: flex;\n  align-items: center;\n  gap: 8px;\n  color: #132775;\n}\n\n.spinner-small {\n  width: 16px;\n  height: 16px;\n  border: 2px solid rgba(19, 39, 117, 0.15);\n  border-top: 2px solid #132775;\n  border-radius: 50%;\n  animation: spin 1s linear infinite;\n}\n\n@keyframes spin {\n  0% { transform: rotate(0deg); }\n  100% { transform: rotate(360deg); }\n}\n\n.loading-text {\n  font-size: 14px;\n  color: #132775;\n  font-weight: 500;\n}\n\n.logout-section {\n  padding: 0 20px 20px 20px;\n  margin-top: auto;\n  display: flex;\n  justify-content: center;\n}\n\n.logout-btn {\n  width: 50%;\n  padding: 12px 0;\n  background: #F6F6F6;\n  color: #000;\n  border: 1px solid #000;\n  border-radius: 8px;\n  font-size: 14px;\n  font-weight: 500;\n  cursor: pointer;\n  transition: all 0.2s ease;\n}\n\n.logout-btn:hover {\n  transform: translateY(-2px);\n}\n\n.logout-btn:active {\n  transform: translateY(0);\n}\n\n@media (max-width: 900px) {\n  .sidebar {\n    position: fixed;\n    top: 0;\n    left: 0;\n    height: 100vh;\n    width: 80vw;\n    max-width: 340px;\n    min-width: 220px;\n    z-index: 1202;\n    background: #f8f9fa;\n    box-shadow: 2px 0 16px rgba(23,32,43,0.12);\n    transform: translateX(-100%);\n    transition: transform 0.3s cubic-bezier(0.4, 0, 0.2, 1);\n    border-right: 1px solid #e9ecef;\n    overflow: hidden;\n  }\n  \n  .sidebar.open {\n    transform: translateX(0);\n  }\n\n  .sidebar:not(.open) {\n    width: 80vw;\n    max-width: 340px;\n    min-width: 220px;\n  }\n\n  .sidebar:not(.open) .sidebar-content {\n    display: flex;\n  }\n\n  .sidebar:not(.open) .sidebar-header {\n    flex-direction: row;\n    align-items: center;\n    justify-content: space-between;\n    padding: 16px 20px;\n  }\n\n  .sidebar:not(.open) .logo-m {\n    margin-bottom: 0;\n  }\n\n  .sidebar:not(.open) .battery-btn {\n    margin-top: 0;\n    opacity: 1;\n    transform: scale(1);\n  }\n\n  .sidebar-header {\n    padding: 12px 16px;\n  }\n  \n  .new-chat-section {\n    padding: 16px;\n  }\n  \n  .chats-section {\n    padding: 0 16px 16px 16px;\n  }\n  \n  .chat-list-item {\n    padding: 10px 12px;\n    font-size: 13px;\n    margin-bottom: 6px;\n  }\n  \n  .circular-btn {\n    width: 44px;\n    height: 44px;\n  }\n} "],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
